import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BinderExportFiles } from 'src/app/models/binder/binder-classification.model';
import { BinderContent } from 'src/app/models/binder/binder-content.model';
import { BinderDocumentType } from 'src/app/models/binder/binder-documentType-model';
import { BinderFilter } from 'src/app/models/binder/binder-filter.model';
import { ReadingMeasurement } from 'src/app/models/binder/binder-reading-measurement.model';
import { BinderUserPermission } from 'src/app/models/binder/binder-user-permission.model';
import { NormalizationFieldExceptionCriteria } from 'src/app/models/normalization-field-exception-criteria.model';

@Injectable({
	providedIn: 'root'
})
export abstract class BaseBinderWizardService {
	public abstract getBinderClassificationDocuments(token: string, binderFilter: BinderFilter): Observable<BinderContent>;
	public abstract getBinderDocumentTypes(token: string): Observable<BinderDocumentType[]>;
	public abstract getJobDocument(token: string, documentId: number): Observable<Blob>;
	public abstract getBinderUserAccess(token: string): Observable<BinderUserPermission>;
	public abstract hasEditBinderAccess(token: string): Observable<boolean>;
	public abstract exportBinderFiles(token: string, binderContent: BinderExportFiles): Observable<void>;
	public abstract getBinderReadingsMeasurements(token: string, documentTypeIds: number[], commonReadingsOnly: boolean): Observable<ReadingMeasurement[]>;
	public abstract getNormalizationFieldExceptionCriterias(): Observable<NormalizationFieldExceptionCriteria[]>;
	public abstract trackBinderSessionDocumentView(req: { token: string; urlHashActionTypeId: number; documentId: number; parentTabId?: number; childTabId?:  number;}): Observable<void>;
}
